import { Linking, Platform } from "react-native";

export const callNumber = (customer) => {
    let phoneLink;

    if (Platform.OS !== "android") {
        phoneLink = `telprompt:${customer.phone}`;
    } else {
        phoneLink = `tel:${customer.phone}`;
    }

    Linking.canOpenURL(phoneLink)
        .then((supported) => {
            if (!supported) {
                console.log("Phone is not available");
            } else {
                return Linking.openURL(phoneLink);
            }
        })
        .catch(() => console.log("Phone is not available"));
};

export const sendWhatsapp = (customer, message) => {
    let contactNumber = customer.phone;

    if (contactNumber.substring(0, 1) == "0") {
        contactNumber = "44" + contactNumber.substring(1, 20);
    }

    let WhatsAppLink = `https://wa.me/${contactNumber}/?text=${encodeURIComponent(message)}`;

    Linking.openURL(WhatsAppLink)
        .then(() => {
            return;
        })
        .catch(() => console.log("Whatsapp is not available"));
};

export const sendEmail = (customer, message) => {
    if (!customer.email) {
        return;
    }

    let emailLink = `mailto:${customer.email}?subject=AutosparesDirect&body=${message}`;

    Linking.canOpenURL(emailLink)
        .then((supported) => {
            if (!supported) {
                console.log("Email is not available");
            } else {
                return Linking.openURL(emailLink);
            }
        })
        .catch(() => console.log("Email is not available"));
};

export const sendSMS = (customer, message) => {
    const smsLink = Platform.OS === "android" ? `sms:${customer.phone}?body=${message}` : `sms:${customer.phone}&body=${message}`;

    Linking.canOpenURL(smsLink)
        .then((supported) => {
            if (!supported) {
                console.log("Text is not available");
            } else {
                return Linking.openURL(smsLink);
            }
        })
        .catch(() => console.log("Text is not available"));
};
